/**
 * @desc 导出佣金统计列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.CommissionManagementPagingQueryParameters): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/stat/export',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
